"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMessageOptionDirty(state) {
    var savedOptions = state.userOptions;
    var soundNotify = owa_options_core_1.getFallbackValueIfNull(state.optionState.soundNotify, !!(savedOptions.NewItemNotify & 1 /* Sound */));
    var emailToastNotify = owa_options_core_1.getFallbackValueIfNull(state.optionState.emailToastNotify, !!(savedOptions.NewItemNotify & 2 /* EMailToast */));
    var emptyDeletedItemsOnLogOut = owa_options_core_1.getFallbackValueIfNull(state.optionState.emptyDeletedItemsOnLogOut, savedOptions.EmptyDeletedItemsOnLogoff);
    return (emptyDeletedItemsOnLogOut !== savedOptions.EmptyDeletedItemsOnLogoff ||
        !!(savedOptions.NewItemNotify & 1 /* Sound */) !== soundNotify ||
        !!(savedOptions.NewItemNotify & 2 /* EMailToast */) !== emailToastNotify);
});
//# sourceMappingURL=isMessageOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-option/lib/utils/isMessageOptionDirty.js
// module id = 5057
// module chunks = 2